import { parse, format } from 'date-fns';
// função para conversão de datas, exemplo de formato:
// yyyy-MM-dd HH:mm:ss
export function formatCustomDate(
  dateString: string,
  inputFormat: string,
  outputFormat: string,
): string {
  if (!dateString) return '';
  try {
    const parsedDate = parse(dateString, inputFormat, new Date());
    return format(parsedDate, outputFormat);
  } catch (error) {
    return '';
  }
}
